//groupCardsByStore.tsx

import { StoreCard, StoreCardGroup } from "../../../lib/types/detailsTypes";

export const isRewardAvailable = (card: StoreCard): boolean => {
  return (
    card.rewards?.some((reward) => card.balance >= reward.balanceRequired) ||
    card.balance >= card.maxBalance
  );
};

export const groupCardsByStore = (cards: StoreCard[]): StoreCardGroup[] => {
  const groupsMap = new Map<string, StoreCardGroup>();

  cards.forEach((card) => {
    try {
      if (!card.storeID) {
        console.warn("Card without storeID found:", card);
        return;
      }

      const groupKey = card.storeID;
      const existingGroup = groupsMap.get(groupKey);

      if (existingGroup) {
        existingGroup.cards.push(card);
        if (!existingGroup.anyRewardAvailable && isRewardAvailable(card)) {
          existingGroup.anyRewardAvailable = true;
        }
      } else {
        groupsMap.set(groupKey, {
          storeURL: card.storeURL,
          storeID: card.storeID,
          storeName: card.storeName,
          city: card.city,
          cards: [card],
          anyRewardAvailable: isRewardAvailable(card),
        });
      }
    } catch (error) {
      console.error("Error grouping card:", card, error);
    }
  });

  return Array.from(groupsMap.values());
};
